import React, { useMemo } from "react";

export const Snowfall = ({ count = 45 }) => {
  const flakes = useMemo(
    () =>
      Array.from({ length: count }, (_, i) => ({
        left: Math.random() * 100,
        size: 8 + Math.random() * 14,
        duration: 9 + Math.random() * 12,
        delay: -Math.random() * 20,
        sway: `${Math.round(Math.random() * 80 - 40)}px`,
        char: i % 3 === 0 ? "❄" : "•",
      })),
    [count]
  );

  return (
    <div className="pointer-events-none fixed inset-0 z-[5] overflow-hidden" aria-hidden data-testid="snowfall">
      {flakes.map((f, i) => (
        <span
          key={i}
          className="snowflake"
          style={{
            left: `${f.left}%`,
            fontSize: f.size,
            animationDuration: `${f.duration}s`,
            animationDelay: `${f.delay}s`,
            "--sway": f.sway,
          }}
        >
          {f.char}
        </span>
      ))}
    </div>
  );
};
